module.exports = __webpack_public_path__ + "media/application/images/preview-open-graph-c64787ab0686077b548b3e36b2cedcc9.png";